import { createSlice } from '@reduxjs/toolkit';

export const writerRedactionData = createSlice({
  name: 'writerRedactionData',
  initialState: {
    keyword: '',
    keywords: '',
    url: '',
    semanticGap: null,
    internalLinking: '',
    isDataAvailable: false,
  },
  reducers: {
    setRedactionData: (state, { payload }) => {
      return {
        ...state,
        keyword: payload.keyword,
        keywords: payload.keywords,
        url: payload.url,
        semanticGap: payload.semanticGap,
        internalLinking: payload.internalLinking,
        isDataAvailable: true,
      };
    },

    clearRedactionData: (state) => {
      state.keyword = '';
      state.keywords = '';
      state.url = '';
      state.semanticGap = null;
      state.internalLinking = '';
      state.isDataAvailable = false;
    },
  },
});

export default writerRedactionData.reducer;

export const {
  setRedactionData,
  clearRedactionData,
  setIntialScoreData,
  setIntialScoreLoading,
} = writerRedactionData.actions;
export const writerRedactionDataSelector = (state) => state.writerRedactionData;
